import * as React from "react";
const Menu = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20,17 L20,18 L4,18 L4,17 L20,17 Z M20,12 L20,13 L4,13 L4,12 L20,12 Z M20,7 L20,8 L4,8 L4,7 L20,7 Z" }));
Menu.displayName = "Menu";
var Menu_default = Menu;
export {
  Menu_default as default
};
